import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_whatsapp.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-640f9986")

_pushScopeId("data-v-640f9986")
const _hoisted_1 = { class: "flex flex-col w-full bg-white" }
const _hoisted_2 = { class: "px-4 py-3 gap-4 flex items-center border-b" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6 cursor-pointer",
  alt: "back"
}, null, -1)
const _hoisted_4 = { class: "text-16px text-black-lp-300 font-semibold flex flex-row items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "rounded-full w-1.5 h-1.5 mx-1.5",
  style: {"background-color":"#D4D5D8"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  class: "rounded-full w-1.5 h-1.5 mx-1.5",
  style: {"background-color":"#D4D5D8"}
}, null, -1)
const _hoisted_7 = { class: "px-4 pt-4 flex flex-col" }
const _hoisted_8 = {
  key: 0,
  class: "w-full flex flex-row justify-between items-center text-sm text-gray-lp-300"
}
const _hoisted_9 = { class: "flex gap-1" }
const _hoisted_10 = {
  class: "font-semibold",
  "data-testid": "pickup-dashboard-booking-selected-count"
}
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = {
  key: 0,
  class: "w-full mt-4 relative"
}
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = { class: "sticky top-0 bg-white z-10 text-sm text-gray-lp-300 font-semibold border-t border-b border-gray-lp-1400" }
const _hoisted_15 = { class: "py-2.5 w-1/20" }
const _hoisted_16 = { class: "p-field-checkbox text-left px-3 flex" }
const _hoisted_17 = { for: "pickup-shipment-checkbox" }
const _hoisted_18 = { class: "py-2.5 w-2/20" }
const _hoisted_19 = { class: "px-3 flex justify-start" }
const _hoisted_20 = { class: "py-2.5 w-3/20" }
const _hoisted_21 = { class: "px-3 flex justify-start" }
const _hoisted_22 = { class: "py-2.5 w-3/20" }
const _hoisted_23 = { class: "px-3 flex justify-start" }
const _hoisted_24 = { class: "py-2.5 w-2/20" }
const _hoisted_25 = { class: "px-3 flex justify-start" }
const _hoisted_26 = { class: "py-2.5 w-2/20" }
const _hoisted_27 = { class: "px-3 flex justify-start" }
const _hoisted_28 = { class: "py-2.5 w-3/20" }
const _hoisted_29 = { class: "px-3 flex justify-start" }
const _hoisted_30 = { class: "py-2.5 w-2/20" }
const _hoisted_31 = { class: "px-3 flex justify-start" }
const _hoisted_32 = { class: "py-2.5 w-2/20" }
const _hoisted_33 = { class: "px-3 flex justify-center" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "justify-end px-3 py-3 font-normal" }
const _hoisted_37 = { class: "p-field-checkbox text-left" }
const _hoisted_38 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_39 = { class: "text-left px-3 py-3" }
const _hoisted_40 = { class: "flex flex-col items-start gap-1" }
const _hoisted_41 = { class: "font-medium" }
const _hoisted_42 = { class: "flex flex-row gap-1" }
const _hoisted_43 = { class: "font-normal text-gray-lp-600" }
const _hoisted_44 = { class: "text-left px-3 py-3" }
const _hoisted_45 = { class: "flex flex-col items-start gap-1" }
const _hoisted_46 = { class: "font-medium" }
const _hoisted_47 = { class: "flex flex-row gap-1" }
const _hoisted_48 = { class: "font-normal text-gray-lp-600" }
const _hoisted_49 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_50 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_51 = { "data-testid": "pickup-dashboard-booking-row-total-quantity" }
const _hoisted_52 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_53 = { class: "text-left px-3 py-3" }
const _hoisted_54 = { class: "text-center px-3 py-3 font-normal" }
const _hoisted_55 = {
  key: 0,
  class: "px-3 bg-white rounded-2xl"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HeaderFilterBar = _resolveComponent("HeaderFilterBar")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, [
          _hoisted_3
        ]),
        _createVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t("pickupDashboard.bookingPickUp")) + ": " + _toDisplayString(_ctx.courierName) + " ", 1),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.id) + " ", 1),
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.formatPhoneNumber(_ctx.courierPhone)), 1)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_HeaderFilterBar, {
          dateRange: _ctx.dateRange,
          "onUpdate:dateRange": [
            _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateRange = $event)),
            _ctx.onChangeDate
          ],
          search: _ctx.search,
          "onUpdate:search": [
            _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = $event)),
            _ctx.onSearch
          ],
          onDownload: _ctx.onDownload,
          showShipmentType: false,
          downloadButtonText: _ctx.$t('pickupDashboard.downloadDataPickUp')
        }, null, 8, ["dateRange", "search", "onDownload", "onUpdate:search", "onUpdate:dateRange", "downloadButtonText"]),
        (_ctx.showBookingButton)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("span", _hoisted_10, _toDisplayString(_ctx.fmtQty(_ctx.shipmentData.filter(item => item.isChecked).length)), 1),
                _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("pickupDashboard.selectedShipment")), 1)
              ]),
              _createVNode(_component_LpButton, {
                iconLeft: "calendar-plus",
                iconV2: "",
                iconColor: "white",
                title: _ctx.$t('pickupDashboard.booking'),
                textColor: "white",
                iconGroupHoverColor: "white",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onBooking(_ctx.checkedShipmentId)))
              }, null, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", null, [
          (_ctx.shipmentData.length || _ctx.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode("div", {
                  class: "courier-table",
                  style: {
              maxHeight: `calc(calc(100vh / var(--viewport-scale)) - ${
                _ctx.showBookingButton ? '370' : '335'
              }px)`
            }
                }, [
                  _createVNode("table", _hoisted_13, [
                    _createVNode("thead", _hoisted_14, [
                      _createVNode("th", _hoisted_15, [
                        _createVNode("div", _hoisted_16, [
                          _createVNode(_component_Checkbox, {
                            class: "mr-4 pickup-checkbox",
                            name: "shipment",
                            modelValue: _ctx.isAllCheked,
                            inputId: `pickup-shipment-checkbox`,
                            binary: true,
                            disabled: _ctx.shipmentData.every(item => !item.isAbleToBooking),
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onCheckAll(!_ctx.isAllCheked)))
                          }, null, 8, ["modelValue", "disabled"]),
                          _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("pickupDashboard.column.no")), 1)
                        ])
                      ]),
                      _createVNode("th", _hoisted_18, [
                        _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("pickupDashboard.column.shipmentId")), 1)
                      ]),
                      _createVNode("th", _hoisted_20, [
                        _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("pickupDashboard.column.courierName")), 1)
                      ]),
                      _createVNode("th", _hoisted_22, [
                        _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("pickupDashboard.column.senderName")), 1)
                      ]),
                      _createVNode("th", _hoisted_24, [
                        _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("pickupDashboard.column.shipmentType")), 1)
                      ]),
                      _createVNode("th", _hoisted_26, [
                        _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("pickupDashboard.column.totalKoli")), 1)
                      ]),
                      _createVNode("th", _hoisted_28, [
                        _createVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("pickupDashboard.column.pickUpDate")), 1)
                      ]),
                      _createVNode("th", _hoisted_30, [
                        _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("pickupDashboard.column.pickUpProof")), 1)
                      ]),
                      _createVNode("th", _hoisted_32, [
                        _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("pickupDashboard.column.booking")), 1)
                      ])
                    ]),
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock("tbody", _hoisted_34, [
                          (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (index) => {
                            return _createVNode("tr", {
                              key: index,
                              class: "cursor-wait border-t border-gray-lp-1400"
                            }, [
                              (_openBlock(), _createBlock(_Fragment, null, _renderList(9, (indexColumn) => {
                                return _createVNode("td", {
                                  key: indexColumn,
                                  class: "px-3 py-3"
                                }, [
                                  _createVNode(_component_Skeleton, { height: "1.3rem" })
                                ])
                              }), 64))
                            ])
                          }), 64))
                        ]))
                      : (_openBlock(), _createBlock("tbody", _hoisted_35, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shipmentData, (item, index) => {
                            return (_openBlock(), _createBlock("tr", {
                              key: `pickup-shipment-${index}`,
                              class: "border-t border-b border-gray-lp-1400 text-sm text-gray-lp-300"
                            }, [
                              _createVNode("td", _hoisted_36, [
                                _createVNode("div", _hoisted_37, [
                                  _createVNode(_component_Checkbox, {
                                    class: "mr-4 pickup-checkbox",
                                    name: "shipment",
                                    modelValue: item.isChecked,
                                    "onUpdate:modelValue": ($event: any) => (item.isChecked = $event),
                                    inputId: `pickup-shipment-checkbox-${index}`,
                                    binary: true,
                                    disabled: !item.isAbleToBooking
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId", "disabled"]),
                                  _createVNode("label", {
                                    for: `pickup-shipment-checkbox-${index}`
                                  }, _toDisplayString(index +
                          1 +
                          _ctx.shipmentPagination.limit *
                            (_ctx.shipmentPagination.page - 1)), 9, ["for"])
                                ])
                              ]),
                              _createVNode("td", _hoisted_38, _toDisplayString(item.shipmentId), 1),
                              _createVNode("td", _hoisted_39, [
                                _createVNode("div", _hoisted_40, [
                                  _createVNode("span", _hoisted_41, _toDisplayString(item.courierId + " - " + item.courierName), 1),
                                  _createVNode("div", _hoisted_42, [
                                    _createVNode("span", _hoisted_43, _toDisplayString(_ctx.formatPhoneNumber(item.courierPhone)), 1),
                                    _createVNode("img", {
                                      onClick: ($event: any) => (_ctx.onClickWhatsapp(item.courierPhone)),
                                      src: _imports_1,
                                      alt: "Whatsapp",
                                      class: "w-4 h-4 cursor-pointer"
                                    }, null, 8, ["onClick"])
                                  ])
                                ])
                              ]),
                              _createVNode("td", _hoisted_44, [
                                _createVNode("div", _hoisted_45, [
                                  _createVNode("span", _hoisted_46, _toDisplayString(item.senderName), 1),
                                  _createVNode("div", _hoisted_47, [
                                    _createVNode("span", _hoisted_48, _toDisplayString(_ctx.formatPhoneNumber(item.senderPhone)), 1),
                                    _createVNode("img", {
                                      onClick: ($event: any) => (_ctx.onClickWhatsapp(item.senderPhone)),
                                      src: _imports_1,
                                      alt: "Whatsapp",
                                      class: "w-4 h-4 cursor-pointer"
                                    }, null, 8, ["onClick"])
                                  ])
                                ])
                              ]),
                              _createVNode("td", _hoisted_49, _toDisplayString(_ctx.mapShipmentType(item.shipmentType)), 1),
                              _createVNode("td", _hoisted_50, [
                                _createVNode("span", _hoisted_51, _toDisplayString(_ctx.fmtQty(item.totalQuantity)), 1)
                              ]),
                              _createVNode("td", _hoisted_52, _toDisplayString(item.statusAt ? _ctx.formatDate(item.statusAt) : "-"), 1),
                              _createVNode("td", _hoisted_53, [
                                _createVNode("span", {
                                  class: ["font-normal", 
                        `${
                          item.proofs.length
                            ? 'underline text-red-lp-100 cursor-pointer'
                            : 'text-gray-lp-300 cursor-auto'
                        }`
                      ],
                                  onClick: ($event: any) => (_ctx.showProof(item))
                                }, _toDisplayString(item.proofs.length
                          ? _ctx.$t("pickupDashboard.viewProof")
                          : "-"), 11, ["onClick"])
                              ]),
                              _createVNode("td", _hoisted_54, [
                                _createVNode(_component_Icons, {
                                  onClick: ($event: any) => (
                        item.isAbleToBooking
                          ? _ctx.onBooking([item.shipmentId])
                          : null
                      ),
                                  name: "calendar-plus",
                                  class: 
                        `w-6 text-gray-lp-800 ${
                          item.isAbleToBooking
                            ? 'cursor-pointer'
                            : 'cursor-not-allowed opacity-50'
                        }`
                      
                                }, null, 8, ["onClick", "class"])
                              ])
                            ]))
                          }), 128))
                        ]))
                  ])
                ], 4),
                (!_ctx.loading)
                  ? (_openBlock(), _createBlock("div", _hoisted_55, [
                      _createVNode(_component_PaginationV3, {
                        pagination: _ctx.shipmentPagination,
                        "onUpdate:pagination": _cache[6] || (_cache[6] = ($event: any) => (_ctx.shipmentPagination = $event)),
                        onSetPage: _ctx.toPageV3,
                        renderedData: _ctx.shipmentData.length,
                        paginationWidth: "w-full",
                        paginationPaddingVertical: "py-1"
                      }, null, 8, ["pagination", "onSetPage", "renderedData"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.errorCause)
              ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                  key: 1,
                  class: "h-full mt-24",
                  errorType: _ctx.errorCause
                }, null, 8, ["errorType"]))
              : (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 2,
                  class: "h-full mt-24",
                  icon: _ctx.emptyData.img,
                  customHeaderMessage: _ctx.emptyData.title,
                  customMessage: _ctx.emptyData.message
                }, null, 8, ["icon", "customHeaderMessage", "customMessage"]))
        ])
      ]),
      _createVNode(_component_ImagePreview, {
        modelValue: _ctx.showImagePreview,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showImagePreview = $event)),
        data: _ctx.images,
        image: _ctx.image,
        isTerm: false,
        onClose: _ctx.closeImagePreview
      }, null, 8, ["modelValue", "data", "image", "onClose"])
    ]),
    _createVNode(_component_WidgetDownload)
  ], 64))
})